/**
 * Ancres de navigation partagées Header / Footer.
 * Labels via i18n (t.nav.*) ; cywiz utilise CywizMark côté UI.
 */
export const PRIMARY_NAV = [
  { key: "studio", href: "#studio", labelKey: "studio" },
  { key: "cywiz", href: "#cywiz", labelKey: null },
  { key: "methode", href: "#methode", labelKey: "methode" },
];

export const FOOTER_NAV = [
  ...PRIMARY_NAV,
  { key: "contact", href: "#contact", labelKey: "contact" },
];
